import { render, staticRenderFns } from "./vip-promotion.vue?vue&type=template&id=1dbdfd34&scoped=true&"
import script from "./vip-promotion.vue?vue&type=script&lang=js&"
export * from "./vip-promotion.vue?vue&type=script&lang=js&"
import style0 from "./vip-promotion.vue?vue&type=style&index=0&id=1dbdfd34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbdfd34",
  null
  
)

export default component.exports